export default "__VITE_ASSET__faiHUZRK__"